import './jquery/location-map'

(function($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        $('.avency-nwd-locations-map').locationMap();
    });
})(jQuery, window, document, window.PageLoadedQueue);
